define('app/helper/play.language',[

  'lodash',
  'jquery',

  'app.env',

  'app/config/constants',

  'app/app.utils',

  'backboneMdl'

], function (_,
  $,
  ENV,
  CONSTANTS,
  UTILS,
  BackboneBase) {

  var LOG_LABEL = 'PlayLanguage'

  const
    SURVEY_ASSET_HASH = ENV.assets_uri.hashCode(),
    STORAGE_BASE_KEY = 'sePlay.language.' + SURVEY_ASSET_HASH,
    DEFAULT_TRANSLATION_FILE_NAME_FORMAT = 'translation.LANGCODE.csv'

  const
    INDEX_SETTINGS_STRING_MAP = {   // mapping the translation file identifier to the index.xml label attributes
      description: 'Description',
      nextlabel: 'NextLabel',
      prevlabel: 'PrevLabel',
      ms_instruction: 'MatrixTextInstruction',
      open_instruction: 'OpenInstruction',
      closed_instruction: 'ClosedInstruction',
      multiple_instruction: 'MultipleInstruction',
      matrix_instruction: 'MatrixInstruction',
      association_instruction: 'AssociationInstruction',
      select_instruction: 'SelectInstruction',
      submitlabel: 'SubmitLabel',
      mandmessage: 'MandMessage',
      generrormessage: 'GenErrorMessage'
    }

  const
    TRANSLATION_TYPE = {
      ITEM: 'item',
      SYSTEM: 'system',
      EXPERIMENT: 'experiment'
    },
    EXPERIMENT_SUBTYPE = {
      PRIORITY: 'dependent variable priority',
      ATTRIBUTE: 'attribute description',
      ALTERNATIVE: 'alternative description',
      LEVEL: 'level'
    }

  const
    VALIDATOR_SYSTEM_STR_FORMAT = new RegExp('^system\\t\\w+(\\t.+)?'),

    //                                             page1    Descrete_Question 17 0  Are you?
    //                                             page1    Level constn_1 17_1 0   Yes
    VALIDATOR_PAGE_STR_FORMAT = new RegExp('^page\\d+\\t\\w+(\\s[a-zA-Z0-9-_]+)+(\\t\\d+)?(\\t.+)?'),

    //                                             experiment1	qlqc_dp_description	Which health state would you prefer?
    //                                             experiment1	alt_const_level1_content	Health State A
    //                                             experiment1	alt_const_level2_content	Health State B
    //                                             experiment1	x1_description	In taking a long walk
    //                                             experiment1	x1_level1_content	You have no trouble
    VALIDATOR_EXPERIMENT_STR_FORMAT = new RegExp('^experiment\\d+\\t\\w+(\\t.+)?')

  var storage = window.localStorage

  var TranslationString = BackboneBase.Model.extend({
    defaults: function () {
      return {
        type: null,         // page, item, experiment
        subtype: null,      // e.g. LEVEL, DERIVED_QUESTION, ...
        stringBaseId: null, // e.g. q8, 1 (experiment idx)
        stringUid: null,    // e.g. q8_1_1, 22 (experiment id)
        subIdData: [],      // e.g. q8_1_1 -> [q8,1,1]
        value: null
      }
    },

    getStringType: function (lineStr) {
      if (lineStr && lineStr.match) {

        if (lineStr.match(VALIDATOR_SYSTEM_STR_FORMAT)) {
          return TRANSLATION_TYPE.SYSTEM

        } else if (lineStr.match(VALIDATOR_PAGE_STR_FORMAT)) {
          return TRANSLATION_TYPE.ITEM

        } else if (lineStr.match(VALIDATOR_EXPERIMENT_STR_FORMAT)) {
          return TRANSLATION_TYPE.EXPERIMENT

        }

      }

      console.error(LOG_LABEL, 'invalid translation line format', lineStr)

      return false
    },

    parse: function (lineStr) {
      var _this = this

      if (!lineStr) return

      var translationType = _this.getStringType(lineStr),
        stringData

      switch (translationType) {
        case TRANSLATION_TYPE.SYSTEM:

          stringData = _this.parseSystemString(lineStr)

          break
        case TRANSLATION_TYPE.ITEM:

          stringData = _this.parseItemString(lineStr)

          break
        case TRANSLATION_TYPE.EXPERIMENT:

          stringData = _this.parseExperimentString(lineStr)

          break
      }

      return stringData
    },

    parseSystemString: function (systemString) {
      var _this = this

      var data = systemString.trim().split('\t'),
        stringData = _this.defaults()

      // set type
      stringData.type = TRANSLATION_TYPE.SYSTEM

      // format: [system,	mandmessage,	1This question must be answered]
      stringData.stringUid = INDEX_SETTINGS_STRING_MAP[data[1]]
      stringData.value = data[2]

      return stringData
    },

    parseItemString: function (itemString) {
      var _this = this

      var data = itemString.trim().split('\t'),
        stringData = _this.defaults()

      // set type
      stringData.type = TRANSLATION_TYPE.ITEM

      var typeIdData = data[1].split(' ') // format: [Level, question_age_1_3, 8_1_3, 0], [Commentary, 0, 6, 0]

      stringData.subtype = typeIdData[0]

      if (typeIdData[1] == 0) {  // if data_label is not set, then use ID
        stringData.stringUid = typeIdData[2]
        stringData.stringBaseId = typeIdData[2]
        stringData.subIdData = [typeIdData[2]]

      } else {
        var subDataIdStr = typeIdData[2].replace(/^\d+/, ''), // 8_1_3 -> _1_3
          baseIdStr = typeIdData[1].replace(subDataIdStr, ''),
          subIdData = subDataIdStr.split('_').slice(1).map(function (val) { return +val })

        subIdData.unshift(baseIdStr)

        stringData.subIdData = subIdData
        stringData.stringUid = typeIdData[1]
        stringData.stringBaseId = baseIdStr
      }

      var value

      switch (data.length) {
        case 2: // format: [page1,	Level q8_1_3 8_1_3 0]
          // this is missing a value for the translation or translation is empty
          value = ''

          break
        case 3: // format: [page1,	Level q8_1_3 8_1_3 0,	Answer 3]

          value = data[2]
          break
        case 4: // format: [page1,	Discrete_Question q8_2 8_2 0,	2,	Answer2]

          value = data[3]
          break
        default:
          console.warn(LOG_LABEL, 'parsing error; unexpected line length', lineStr, data, data.length)
          break
      }

      if (value && value.match(/<BR>/)) { // BAD BAD linebreak to <BR> conversion done in translation files
        value = value.replace(/<BR>/gm, '\n')
      }

      stringData.value = value

      return stringData

    },
    parseExperimentString: function (experimentString) {
      var _this = this

      var data = experimentString.trim().split('\t'),
        stringData = _this.defaults()

      // set type
      stringData.type = TRANSLATION_TYPE.EXPERIMENT

      /*
       experiment1	qlqc_dp_description	Which health state would you prefer?

       /^experiment(\d+)$/
                      /_dp_description$/
                      "".split("_")[0]
                                          content

       experiment1	alt_const_level1_content	Health State A

                      /^alt_const_level(\d+)/ -> [0] alt idx
                                          content

       experiment1	alt_const_level2_content	Health State B
       experiment1	x1_description	In taking a long walk

                      /^(x\d+)_description$/ -> [0] attr id
                                          content

       experiment1	x1_level1_content	You have no trouble

                      /^(x\d+)_level(\d+)_content$/ -> [0] attr id, [1] level idx
       */

      var tmpMatch,
        experimentIdx

      // get experiment idx
      if (tmpMatch = data[0].match(/^experiment(\d+)/)) {
        experimentIdx = +tmpMatch[1]
      }

      if (!experimentIdx) {
        console.error(LOG_LABEL, 'bad experiment string, no experiment index found', data[0], data)
        return
      }

      stringData.stringBaseId = experimentIdx

      // subtype: experiment dependent variable description
      if (tmpMatch = data[1].match(/^(\w+)_dp_description$/)) {

        stringData.subtype = EXPERIMENT_SUBTYPE.PRIORITY

        stringData.stringUid = tmpMatch[1]

        // subtype: alternative description
      } else if (tmpMatch = data[1].match(/^alt_const_level(\d+)/)) {

        stringData.subtype = EXPERIMENT_SUBTYPE.ALTERNATIVE

        stringData.stringUid = tmpMatch[1]

        // subtype: attribute description
      } else if (tmpMatch = data[1].match(/^(x\d+)_description$/)) {

        stringData.subtype = EXPERIMENT_SUBTYPE.ATTRIBUTE

        stringData.stringUid = tmpMatch[1]

        // subtype: level description
      } else if (tmpMatch = data[1].match(/^(x\d+)_level(\d+)_content$/)) {

        stringData.subtype = EXPERIMENT_SUBTYPE.LEVEL

        stringData.stringUid = tmpMatch[1] + '_' + tmpMatch[2]
        stringData.subIdData = [tmpMatch[1], tmpMatch[2]]

      } else {
        console.error(LOG_LABEL, 'bad experiment string format; subtype not found', data[1], data)
        return
      }

      stringData.value = data[2]

      return stringData
    }
  })

  var TranslationStore = BackboneBase.Collection.extend({
    model: TranslationString,
    language: null,
    orig: null, // translation storage with default translations
    status: CONSTANTS.STATUS.INIT,

    init: function (settings) {
      var _this = this

      if (!settings) {
        return
      }

      _this.on('hasLoaded', function () {
        _this.setStatus(CONSTANTS.STATUS.LOADED)
      })

      _this.orig = settings.orig

      return _this.load(settings.language, true)
    },

    /**
     * loads a new translation file from the assets directory
     * @param language  string; used to find translation file in assets_uri/translation.language.csv
     * @param forced    boolean; force reload of language
     */
    load: function (language, forced) {
      var _this = this

      var _return = $.Deferred()

      if (!language) {
        console.error(LOG_LABEL, 'missing language parameter', language)
        _return.reject()

      } else if (language === _this.language && !forced) {
        _return.reject()

      } else {
        _this.reset()

        _this.language = language

        _this.fetch({
          success: _return.resolve,
          error: _return.reject
        })
      }

      return _return.promise()
    },

    sync: function (method, model, options) {
      options.parse = true

      var _this = model || this

      var succCb0 = options.success || function () {
        },
        errCb0 = options.error || function () {
        }

      switch (method) {
        case 'read':

          _this.reset()

          var translationFileUri =
            (ENV.assets_uri + '/').replace(/\/\/$/, '/') +
            DEFAULT_TRANSLATION_FILE_NAME_FORMAT.replace('LANGCODE', _this.language)

          $.get(translationFileUri)
            .done(function (fileDataStr) {
              succCb0(fileDataStr)
              _this.trigger('hasLoaded')
            })
            .fail(function () {
              console.warn(LOG_LABEL, 'failed to read translation file', translationFileUri)
            })

          break
        case 'create':
        case 'update':
          break
        case 'delete':
          break
      }

    },

    validate: function (translationFileStr) {
      var _this = this

      if (!translationFileStr || translationFileStr.trim() === '') {
        console.error(LOG_LABEL, 'no translations found!')
        return false
      }

      return true
    },

    parse: function (translationFileStr) {
      var _this = this

      if (!_this.validate(translationFileStr)) {
        return
      }

      return translationFileStr.trim().split('\n')
    },

    getBaseTranslations: function () {
      var _this = this

      if (!_this.status < CONSTANTS.STATUS.LOADED) return

      return _this.where({
        type: TRANSLATION_TYPE.SYSTEM
      }).map(function (translMdl) { return _this._translationToJson(translMdl) })
    },

    getTranslations: function (seItemId) {
      var _this = this

      if (!_this.status < CONSTANTS.STATUS.LOADED) return

      return _this.where({
        type: TRANSLATION_TYPE.ITEM,
        stringBaseId: seItemId
      }).map(function (translMdl) { return _this._translationToJson(translMdl) })
    },

    // getExperimentTranslations: function(experimentId){
    //     var _this = this;
    //
    //     if(!_this.status < CONSTANTS.STATUS.LOADED) return;
    //
    //     var experimentIdx;
    //
    //     _this.where({
    //         type: TRANSLATION_TYPE.EXPERIMENT,
    //         subtype: EXPERIMENT_SUBTYPE.PRIORITY,
    //         stringUid: experimentId
    //     }).map(function(translMdl){
    //         experimentIdx = translMdl.get("stringBaseId")
    //     });
    //
    //
    //     return _this.where({
    //         type: TRANSLATION_TYPE.EXPERIMENT,
    //         stringBaseId: experimentIdx
    //     }).map(function(translMdl){ return _this._translationToJson(translMdl); });
    // },

    getErrorStrings: function () {
      var _this = this

      if (!_this.status < CONSTANTS.STATUS.LOADED) return

      var errorStrings = {},
        validationErrorStrings = _this.where({
          type: TRANSLATION_TYPE.ITEM,
          subtype: 'Validation'
        }).map(function (translMdl) {
          var tsObj = _this._translationToJson(translMdl)
          errorStrings[tsObj.orig] = tsObj.value
        }),
        systemMandatoryErrorStrings = _this.where({
          type: TRANSLATION_TYPE.SYSTEM,
          stringUid: INDEX_SETTINGS_STRING_MAP.mandmessage
        }).map(function (translMdl) {
          var tsObj = _this._translationToJson(translMdl)
          errorStrings[tsObj.orig] = tsObj.value
        })

      if (validationErrorStrings.length === 0 && systemMandatoryErrorStrings.length === 0)
        return

      return errorStrings
    },

    _translationToJson: function (translStrMdl) {
      var _this = this
      var translationObj = translStrMdl.toJSON(),
        origTranslation

      if (_this.orig) {
        origTranslation = _this.orig.findWhere({ stringUid: translationObj.stringUid })
        if (origTranslation) {
          translationObj.orig = origTranslation.get('value')
        }
      }

      return translationObj
    }
  })

  /**
   * Language Helper
   *
   * init: read available translations either from storage or on init into translations stores
   * load: load up a specific language
   *
   * @typedef LanguageMdl
   * @extends BackboneBaseModel
   */
  /**
   * @type LanguageMdl
   */
  var Language = BackboneBase.Model.extend(/** @lends LanguageMdl.prototype */{
    defaults: function () {
      return {
        languages: [],      // available languages, default is first
        language: null      // current language
      }
    },

    translations: {},   // format: language: TranslationStore

    init: function (settings) {
      var _this = this

      if (!settings) {
        settings = _this._readStorage()
      }

      if (_this.status < CONSTANTS.STATUS.LOADING) {
        _this.on('change:language', function () {
          _this._saveToStorage()
        })
      }

      _this._readSettings(settings)
    },

    load: function (language) {
      var _this = this

      var languages = _this.get('languages')
      if (!languages || languages.indexOf(language) === -1) {
        console.error(LOG_LABEL, 'language not found', language, languages)
        return
      }

      _this.set('language', language)

      if (_this.translations[language].status === CONSTANTS.STATUS.LOADED)
        _this.trigger('hasLoaded')
    },

    _readSettings: function (settings) {
      var _this = this

      if (!settings) return

      if (_.isEqual(settings, _this.get())) return

      if (!settings.languages || !settings.languages.length) {
        console.error(LOG_LABEL, 'missing parameter languages', settings)
        return
      }

      if (!settings.language) {
        settings.language = settings.languages[0]
      }

      _this.set(settings)

      _this._updateTranslations()

    },

    _updateTranslations: function () {
      var _this = this

      _this.setStatus(CONSTANTS.STATUS.LOADING)

      var languages = _this.get('languages'),
        origTS,
        translationsLoaded = 0

      _this.translations = {}

      if (languages && languages.length > 0) {
        _.each(languages, function (lang) {
          var ts = new TranslationStore()

          ts.init({ language: lang, orig: origTS }).done(function () {
            translationsLoaded++
            if (translationsLoaded === languages.length) {
              _this.trigger('hasLoaded')
            }
          })

          if (!origTS) {
            origTS = ts
          }

          _this.translations[lang] = ts
        })
      } else {

        _this.trigger('hasLoaded')
      }
    },

    _readStorage: function () {
      var _this = this
      if (!storage) {
        console.warn(LOG_LABEL, 'session storage can no be accessed! settings could not be read.')
        return
      }

      var settings
      try {
        settings = JSON.parse(atob(storage.getItem(STORAGE_BASE_KEY)))
      } catch (err) {}

      return settings
    },

    _saveToStorage: function () {
      var _this = this
      if (!storage) {
        console.warn(LOG_LABEL, 'session storage can no be accessed! settings could not be saved.')
        return
      }

      storage.setItem(STORAGE_BASE_KEY, btoa(JSON.stringify(_this.toJSON())))
      return true
    },

    /**
     *
     * @returns {[]|null}
     */
    getBaseTranslations: function () {
      var _this = this

      if (_this.status < CONSTANTS.STATUS.LOADED) return

      var lang = _this.get('language')

      return _this.translations[lang].getBaseTranslations()
    },

    getTranslations: function (seItemId) {
      var _this = this

      if (_this.status < CONSTANTS.STATUS.LOADED) return

      var lang = _this.get('language')

      return _this.translations[lang].getTranslations(seItemId)
    },

    getErrorStrings: function () {
      var _this = this

      if (_this.status < CONSTANTS.STATUS.LOADED) return

      var lang = _this.get('language')

      return _this.translations[lang].getErrorStrings()
    }
    // ,
    // getExperimentTranslations: function(experimentId){
    //     var _this = this;
    //
    //     if(_this.status < CONSTANTS.STATUS.LOADED) return;
    //
    //     var lang = _this.get("language");
    //
    //     return _this.translations[lang].get
    // }

  })

  var language = new Language()

  // get language
  var SePlay = window.SePlay = window.SePlay || {}
  SePlay.Language = language

  return language

});
